import { PlusIcon } from '@persona-id/design-tokens/icons';

import Button from 'design-system/components/Button';

interface HeaderActionsProps {
  canAdd: boolean;
  canSave: boolean;
  isSubmitting?: boolean;
  onAdd: () => void;
}

const HeaderActions: React.FC<HeaderActionsProps> = ({
  canAdd = true,
  canSave = true,
  isSubmitting,
  onAdd = () => {},
}) => {
  return (
    <>
      <Button
        id='field-schema-editor__create-field-button'
        variant='basic'
        size='md'
        disabled={!canAdd}
        prefixIcon={<PlusIcon />}
        onClick={onAdd}
      >
        Add Field
      </Button>
      <Button
        id='field-schema-editor__save-field-button'
        variant='basic'
        type='submit'
        size='md'
        disabled={!canSave}
        isPending={isSubmitting}
      >
        Save
      </Button>
    </>
  );
};

export default HeaderActions;
